// extracted by mini-css-extract-plugin
module.exports = {"buttonsContainer":"OnGoingPaymentBox_buttonsContainer__iH6vT","resendInfoText":"OnGoingPaymentBox_resendInfoText__1fR-V"};